import React, { useState, useEffect } from "react";
import "./PayrollBatch.scss";
import PayrollBatchTabs from "../../components/PayrollBatchTabs/PayrollBatchTabs";
import { getBatchList } from "../../util/API/batch";
import { useSelector } from "react-redux";
import { searchAppsByLabel } from "../../util/utilfunctions/utilFunctions";
import { Box } from "@mui/material";
import { getMaintenanceStatus } from "../../util/API/tableServices";

function PayrollBatch() {
  const [batchList, setBatchList] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // For initial fetch
  const [error, setError] = useState(null); // For fetch failures
  const [securityPermissions, setSecurityPermissions] = useState({});
   const [displayPreMaintenanceBanner, setDisplayPreMaintenanceBanner] =
    useState(false);

  const securityAccess = useSelector((state) => state.login.securityAccess);

  // Check displayPreMaintenanceBanner flag
  useEffect(()=> {
    getPreMaintenanceBannerStatus();
  },[]);

  useEffect(() => {
    const payrollPermission = searchAppsByLabel("payroll batch", securityAccess);
    if (payrollPermission.length > 0) {
      setSecurityPermissions(payrollPermission[0]);
    }
  }, [securityAccess]);

  useEffect(() => {
    const fetchPayrollBatches = async () => {
      setIsLoading(true); // Ensure loading starts
      setError(null); // Reset error
      try {
        const results = await getBatchList();
        if (results.callStatus == 1) {
          let records = results.payload.record;
          if (!Array.isArray(records)) {
            records = records ? [records] : [];
          }

          // Filter only payroll-related batches by ID
          const payrollBatches = records.filter((batch) => 
            batch.batchfilecategories.categoryid === "33" // Use string comparison; adjust if API returns number
          );

          setBatchList(payrollBatches);
        } else {
          setError("API returned an error status.");
        }
      } catch (err) {
        setError("Failed to load payroll batches: " + err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPayrollBatches();
  }, []);

  const getNewBatchList = (updatedList) => {
    setBatchList(updatedList);
  };

  const getPreMaintenanceBannerStatus = async () => {
    try {
      const baseUrl =
        window.location.protocol + "//" + window.location.host;
      const encodedUrl = btoa(baseUrl);
      const response = await getMaintenanceStatus(encodedUrl);

      if (
        response &&
        response.Status === "1" &&
        response.payload &&
        response.payload.displayPreMaintenanceBanner === true
      ) {
        setDisplayPreMaintenanceBanner(true);
      } else {
        setDisplayPreMaintenanceBanner(false);
      }
    } catch (err) {
      console.error(
        "Failed to retrieve pre-maintenance banner status:",
        err
      );

      // Hide the banner if the maintenance-status request fails.
      setDisplayPreMaintenanceBanner(false);
    }
  };

  return (
    <Box className="page-container">
      {displayPreMaintenanceBanner && (
        <Box className="pre-maintenance-banner">
          To improve your overall experience, a system maintenance is
          scheduled for Wednesday, August 26 from 12:00 AM to 4:00 AM EST. Thank
          you for your patience in this regard. We look forward to
          serving you better.
        </Box>
      )}
      
      <Box className="header-container">
        <Box className="page-title">Payroll Batch Services</Box>
      </Box>

      <Box className="batch-tabs">
        {isLoading ? (
          <Box sx={{ p: 8, textAlign: "center", color: "#888" }}>
            Loading payroll batch services...
          </Box>
        ) : error ? (
          <Box sx={{ p: 8, textAlign: "center", color: "red" }}>
            {error} Please try again or contact support.
          </Box>
        ) : (
          <PayrollBatchTabs
            batchList={batchList}
            userPermissions={securityPermissions}
            getNewBatchList={getNewBatchList}
          />
        )}
      </Box>
    </Box>
  );
}

export default PayrollBatch;